import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import {
  buildWorkOrderStockReceiptCreatePayload,
} from '#/api/momMgmt/workOrder/inbound/serializeInboundWrite';

/**
 * 工單巢狀完工入庫 create（`mom.work_order.stock_receipt.create`）。
 * POST `/mom/work-order/{workOrderId}/stock-receipt` → 201。
 * 僅 PROCESSING；後端固定 source WORK_ORDER。
 *
 * @param {string} workOrderId
 * @param {object} values camel 表單／payload（見 serializeInboundWrite）
 */
export async function createWorkOrderStockReceipt(workOrderId, values) {
  const { data: raw } = await request.post(
    `/mom/work-order/${workOrderId}/stock-receipt`,
    keysToSnake(buildWorkOrderStockReceiptCreatePayload(values)),
  );
  return parseVer4DetailResponse(raw);
}
